import { useTranslation } from '@gimlite/common';
import { observer } from 'mobx-react-lite';
import GC_full from '../assets/logo/GC_full';
import { Button } from '../components/button/button.component';
import { Col } from '../components/col/col.component';
import { Main } from '../components/main/main.component';
import { Page } from '../components/page/page.component';
import { Status } from '../components/status/status.component';
import { Text } from '../components/text/text.component';
import { useStoreUIV2 } from '../hooks/useStore.hook';

export const Page498 = observer(() => {
  const { SSOStore } = useStoreUIV2();
  const { t } = useTranslation();

  return (
    <Main mode="landing" logo={<GC_full />} onNavigate={(path) => {}}>
      <Page>
        <Col height="100%" alignItems="center" justifyContent="center" gap={16}>
          <Col alignItems="center" justifyContent="center" gap={8}>
            <Status
              icon="alarm"
              backgroundColor="black_4"
              foregroundColor="black_50"
            />
            <Col alignItems="center" justifyContent="center">
              <Text variant="headline">{t('watermelon-498_TITLE')}</Text>
              <Text variant="body">{t('watermelon-498_DESCRIPTION')}</Text>
            </Col>
          </Col>

          <Button
            onClick={() => {
              SSOStore.instance?.login();
            }}
            iconLeft="arrow_left"
            variant="primary"
          >
            {t('watermelon-logIn')}
          </Button>
        </Col>
      </Page>
    </Main>
  );
});
